<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oWRlNI/images/Cover.jpg?1696786074505" alt="This image is the cover for the book Rick and Morty Vol. 2: Deluxe Double Feature, Rick and Morty"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rick and Morty Vol. 2: Deluxe Double Feature, Rick and Morty
      </h1>
      <p class="bookDescription body article font2">
        <p>The hit comic book series based on the hilarious [adult swim]™ animated show Rick and Morty™ continues in all-new stories not seen on TV! In Deluxe Double Feature Vol. 2, only Morty can save the outrageous S**t Dragons embroiled in a tantalizing adventure in Rick and Morty: Worlds Apart. When Morty stupidly agrees to all the legal terms of a new app and legally signs his life away to a faceless and unheard-of company, they immediately seize control of him and his life for their own purposes, in Rick and Morty: Corporate Assets.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josh Trujillo, Tony Fleecs, Jarrett Williams, Leonardo Ito
      </h2>
      
      <p class="authorDescription body article">Josh Trujillo is a writer, editor, and comic book creator based in San Rafael, California. He has worked with clients including Boom! Studios, Dark Horse Comics, Shanken Creative Group, Oni Press, Telltale Games, and DC Comics, among others. His work spans different genre and audiences, specializing in children's fiction, fantasy, humor, history, romance, gaming, and LGBTQ issues. Trujillo speaks for inclusiveness and diversity in popular media, and works alongside groups including the USC ONE Archive and Prism Comics. Josh loves his dog, his country, and is of good moral fiber. You can remain updated on his work by following Josh on Twitter @LostHisKeysMan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Oni Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a19708a4